module.exports = __webpack_public_path__ + "static/media/ChannelSong.Marathi.5822167e.jpg";